<template>
  <div>
    <div class="container-fluid">
      <div class="pt-4">
        <h2><strong>Dashboard</strong></h2>
      </div>
    </div>

    <div class="container-fluid">
      <div class="btn-group d-flex mt-5 dashboard-nav" role="group">
        <router-link
            v-for="app in apps"
            :key="app.id"
            :class="{
              'btn-dashboard-nav-active': isActive(app.path),
            }"
            :to="app.path"
            class="btn btn-dashboard-nav w-100">
          <h4>{{ app.description }}</h4>
        </router-link>
      </div>
    </div>

    <router-view v-if="generalInfo || (currentApp.active && allowedApp)"/>

    <div v-else-if="allowedApp && currentApp.status === 'expired'" class="container-fluid">
      <div class="row mt-5">
        <div class="col-md-12">

          <ExpiredApp :name="currentApp.nickname">
            <router-link :to="`/apps/${currentApp.name}`" class="btn btn-outline my-3 px-5">
              Contratar App
            </router-link>
          </ExpiredApp>

        </div>
      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="row mt-5">
        <div class="col-md-12">

         <NotFound/>

        </div>
      </div>
    </div>

  </div>

</template>
<script>
  import GetAccountApps from '@/mixins/GetAccountApps'
  import ExpiredApp from '@/components/dashboard/ExpiredApp'
  import NotFound from '@/components/shares/NotFound'
  import GetUser from '@/mixins/GetUser'
  import GetAccount from '@/mixins/GetAccount.vue'
  import GetPartner from '@/mixins/GetPartner.vue'
  import { getAppDisplayName } from '@/appDisplayNames'
  import { DRIVER_INDICATION, hasActiveProduct } from '@/models/accountProducts'

  export default {
    components: { ExpiredApp, NotFound },
    computed: {
      apps() {
        let apps = this.links.map(link => {
          let app = this.getAccountApps.find(app => app.name === link.name)

          // Special handling for driver-indication - check feature flag instead of accountApp
          if (link.name === 'driver-indication') {
            const isEnabled = this.isDriverIndicationEnabled
            app = { active: isEnabled, name: 'driver-indication' }
          }

          const description = getAppDisplayName(link.name, this.getPartner)
          link = { ...link, description }

          return {...app, ...link }
        })

        apps = apps.filter(app => this.$withPolicy(app.name, 'viewer'))

        apps.unshift( {
          active: true, description: 'Informações gerais', name: '', path: '/dashboard'
        })
        return apps.filter(app => app.active || app.status === 'expired')
      },
      isDriverIndicationEnabled() {
        return hasActiveProduct(this.getAccountApps, DRIVER_INDICATION)
      },
      currentApp() {
        const path = this.$route.path.replace('/dashboard/', '')
        return this.getAccountApps.find(app => app.name === path)
      },
      allowedApp() {
        return !!this.currentApp && this.$withPolicy(this.currentApp.name, 'viewer')
      },
      expired() {
        const app = this.getAccountApps.find(accountApp => accountApp.name === 'message')
        return app && app.status === 'expired'
      },
      generalInfo() {
        return !this.currentApp
      }
    },
    data() {
      return {
        links: [
          { name: 'dfe', path: '/dashboard/dfe' },
          { name: 'cm-frotas', path: '/dashboard/cm-frotas'},
          { name: 'driver-indication', path: '/indicacao-condutores'},
          { name: 'cm-taxas', path: '/cm-taxas'},
          { name: 'cm-embarcador', path: '/dashboard/cm-embarcador'},
          { name: 'cm-crono', path: '/dashboard/cm-crono'}
        ]
      }
    },
    methods: {
      isActive(pathLink) {
        let path = this.$route.path
        return (pathLink === '/dashboard' && path === '/') || pathLink === path
      }
    },
    mixins: [GetAccountApps, GetUser, GetAccount, GetPartner],
    name: 'Index'
  }
</script>

<style scoped>

</style>
